<div class="p-grid p-justify-even p-mb-6">
  <div class="p-col-12" *ngIf="regulacionPlazas.length > 0">
    <div class="p-grid p-jc-between">
      <div class="p-col-6">
        <h3>{{title}}</h3>
      </div>
      <div class="p-col-3 p-d-flex p-jc-end">
        <p-dropdown [options]="optionMapas" optionLabel="header" name="selectorMapas" [(ngModel)]="mapSelected"
          (onChange)="changeMap()"></p-dropdown>
      </div>
    </div>
    <!-- Estado plazas-->
    <div class="p-grid">
      <div class="p-col-12 cont">
        <div>
          <div class="buttonToogle">
            <p-button *ngIf="showLeftButton" icon="pi pi-chevron-left"
              [pTooltip]="'GLOBAL.OCULTAR.FORM.RUTAS' | translate" tooltipPosition="top" (click)="ocultarPanel()">
            </p-button>
            <p-button *ngIf="showRightButton" icon="pi pi-chevron-right"
              [pTooltip]="'GLOBAL.MOSTRAR.FORM.RUTAS' | translate" tooltipPosition="top" (click)="mostrarPanel()">
            </p-button>
          </div>
          <div class="buscador-rutas" *ngIf="showPanel">
            <form #formRoute="ngForm">
              <div class="p-grid">
                <div class="p-col-1 p-d-flex p-ai-center">
                  <p-button p-pButton icon="pi pi-sort-alt" type="submit " (click)="cambiarOrdenOrigDest()"></p-button>
                </div>
                <div class="p-col-10">
                  <span class="ui-float-label p-m-2 w-100 p-d-flex p-jc-around">
                    <p-autoComplete required name="origen" id="origen" 
                      [placeholder]="'GLOBAL.RUTA.ORIGEN' | translate"
                      [(ngModel)]="origen" 
                      [suggestions]="calles" 
                      (completeMethod)="buscarCalle($event, true)"
                      field="tipoYCalle" 
                      [forceSelection]="true" 
                      (click)="selectedInputs('origen')"
                      (onSelect)="onSelect($event,'origen')"
                      ></p-autoComplete>
                    <p-dropdown 
                        name="origenCombo" id="origenCombo" 
                        [style]="{'minWidth':'100%','width': '65px'}" 
                        [placeholder]="'Num.'"
                        class="input-numero-orgi-dest" 
                        [options]="numerosPoliciaOrigen" 
                        [(ngModel)]="origenNp"
                        (ngModelChange)="onSelectNumeroPolicia('origen')">
                    </p-dropdown>
                  </span>
                  <span class="ui-float-label p-m-2 w-100 p-d-flex p-jc-around">
                    <p-autoComplete required name="destino" id="destino" 
                      [placeholder]="'GLOBAL.RUTA.DESTINO' | translate" 
                      [(ngModel)]="destino" 
                      [suggestions]="calles" 
                      (completeMethod)="buscarCalle($event, false)" 
                      field="tipoYCalle" 
                      [forceSelection]="true" 
                      (click)="selectedInputs('destino')"
                      (onSelect)="onSelect($event,'destino')"></p-autoComplete>
                   <p-dropdown 
                      name="destinoCombo" id="destinoCombo" 
                      [style]="{'minWidth':'100%','width': '65px'}" 
                      [placeholder]="'Num.'"
                      class="input-numero-orgi-dest" 
                      [options]="numerosPoliciaDestino" 
                      [(ngModel)]="destinoNp"
                      (ngModelChange)="onSelectNumeroPolicia('destino')">
                  </p-dropdown>
                  </span>
                </div>
                <div class="p-col-1 p-d-flex p-ai-center">
                  <p-button p-pButton icon="fas fa-location-arrow" type="submit "
                    [pTooltip]="'GLOBAL.OBTENER.ORIGEN.ACTUAL.USUARIO' | translate" tooltipPosition="top"
                    (click)="getPositionUser()"></p-button>
                </div>
              </div>
              <div class="p-grid p-jc-between">
                <div class="p-col-6">
                  <p-button class="pr-2 pl-2 pb-1 pt-1 " p-pButton
                    [label]=" 'GLOBAL.LIMPIAR.FORMULARIO.RUTA' | translate " icon="fas fa-eraser" type="submit "
                    (click)="limpiarForm()"></p-button>
                </div>
                <div class="p-col-6">
                  <p-button class="pr-2 pl-2 pb-1 pt-1 " p-pButton [label]=" 'GLOBAL.OBTENER.RUTA' | translate "
                    icon="pi pi-search" type="submit " (click)="calcularRuta()" [disabled]="!origenNp || !destinoNp">
                  </p-button>
                </div>
              </div>

            </form>

            <div class="info-ruta p-m-3" *ngIf="ruta">
              <div class="p-grid">
                <div class="p-col-12">
                  <h3 class="sm-font">{{'GLOBAL.INFORMACION.RUTA' | translate}}</h3>
                  <div class="delim"></div>
                </div>
              </div>
              <div class="p-grid p-mt-1 c">
                <div class="p-col-6">
                  <h4 class="w-100 sm-font">{{'GLOBAL.INFORMACION.RUTA.DISTANCIA' |translate}}</h4>
                  <p>{{ruta.routes[0].distance |formatPersonalText: 'distRuta' }}</p>
                </div>
                <div class="p-col-6">
                  <h4 class="w-100 sm-font">{{'GLOBAL.INFORMACION.RUTA.DURACION' |translate}}</h4>
                  <p>{{ruta.routes[0].duration |formatPersonalText: 'durRuta'}}</p>
                </div>
              </div>
              <div class="p-grid p-mt-2">
                <div class="p-col-12">
                  <h3 class="sm-font">{{'GLOBAL.INDICACIONES.RUTA' | translate}}</h3>
                  <div class="delim"></div>
                </div>
              </div>
              <div class="p-grid">
                <div class="p-col-12 p-m-1" *ngFor="let step of ruta.routes[0].legs[0].steps">
                  <span *ngIf="!step.maneuver.modifier">
                    <i [class]="'' |formatPersonalText: 'dirStepRuta_' +step.maneuver.type"></i>
                    {{step.name}} {{'GLOBAL.INDICACIONES.RUTA.DURANTE' | translate}} {{step.distance}}
                    {{'GLOBAL.INDICACIONES.RUTA.METROS' | translate}}
                  </span>
                  <span *ngIf="step.maneuver.modifier">
                    <i [class]="'' |formatPersonalText: 'dirStepRuta_' +step.maneuver.modifier"></i>
                    {{step.name}}
                    {{step.ref}}
                    {{'GLOBAL.INDICACIONES.RUTA.DURANTE' | translate}}
                    {{step.distance}}
                    {{'GLOBAL.INDICACIONES.RUTA.METROS' | translate}}
                  </span>
                </div>
              </div>
            </div>
            <!-- Fin Informacion de la Ruta-->
          </div>
        </div>

        <div class="leyenda-colores-main" *ngIf="mapSelected.field === 'estado_plazas' || mapSelected.field === 'estado_plaza_por_duracion_ultima_semana'">
          <div class="buttonToogle-leyenda-colores">
            <p-button *ngIf="mostrarColoresEstadoPlaza" icon="pi pi-chevron-left"
              [pTooltip]="'GLOBAL.MOSTRAR.LEYENDA.COLORES' | translate" tooltipPosition="bottom" (click)="ocultarLeyendaEstadoPlazas()">
            </p-button>
            <p-button *ngIf="!mostrarColoresEstadoPlaza" icon="pi pi-chevron-right"
              [pTooltip]="'GLOBAL.OCULTAR.LEYENDA.COLORES' | translate" tooltipPosition="bottom" (click)="mostrarLeyendaEstadoPlazas()">
            </p-button>
          </div>
          <div class="leyenda-colores p-pt-1" [hidden]="!mostrarColoresEstadoPlaza">
            <h6 class="titulo-leyenda-colores">Leyenda colores estado plazas</h6>
          <div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plazas'">
            <div class="span-colores" style="background: #2E802E;"></div>
            Plaza Disponible
          </div>
          <div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plaza_por_duracion_ultima_semana'">
            <div class="span-colores" style="background: #2E802E;"></div>
            Disponibilidad Alta
          </div>
          <div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plazas'">
            <div class="span-colores" style="background: #5881DF;"></div>
            Alarma activa 
          </div>
          <!--<div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plaza_por_duracion_ultima_semana'">
            <div class="span-colores" style="background: #5881DF;"></div>
            Alarma activa 
          </div>-->
          <div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plazas'">
            <div class="span-colores" style="background: #D4001D;"></div>
            Plaza ocupada 
          </div>
          <div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plaza_por_duracion_ultima_semana'">
            <div class="span-colores" style="background: #D4001D;"></div>
            Disponibilidad baja 
          </div>
          <div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plazas'">
            <div class="span-colores" style="background: #000000;"></div>
            Plaza no disponible 
          </div>
          <div class="p-d-flex p-jc-between p-mt-3 color w-75 m-auto" *ngIf="mapSelected.field === 'estado_plaza_por_duracion_ultima_semana'">
            <div class="span-colores" style="background: #E5EE64;"></div>
            Disponibilidad media
          </div>
        </div>
        </div>
        <!-- Estados plazas -->
        <dum-ol-map-plazas *ngIf="mapSelected.field === 'estado_plazas'" 
          width="100%" 
          height="550px" 
          [lat]="latInicio" 
          [lon]="lonInicio" 
          [plazas]="regulacionPlazas"
          (eventGetLonLat)="getDestOrigClickEx($event)">
        </dum-ol-map-plazas>
        <!-- Estados barrios -->
        <dum-ol-map-barrios 
          *ngIf="mapSelected.field === 'estado_barrios'" 
          width="100%" 
          height="550px"
          [subBarrios]="datosSubBarrios" 
          (eventGetLonLat)="getDestOrigClickEx($event)">
        </dum-ol-map-barrios>
        <!-- Disponibilidad media diaria última semana -->
        <dum-ol-map-plaza-diponibilidad-semanal
            *ngIf="mapSelected.field === 'estado_plaza_por_duracion_ultima_semana'"
            width="100%"
            height="550px"
            [plazas]="regulacionPlazaInforme"
            (eventGetLonLat)="getDestOrigClickEx($event)"
        ></dum-ol-map-plaza-diponibilidad-semanal>
        <dum-spinner *ngIf="loadingSpinner"></dum-spinner>
      </div>
    </div>
  </div>
</div>
<dum-toast #dumToast></dum-toast>
